import React from "react";
import { Container, Row, Col } from "shards-react";
import Booking from "../components/common/bookings/Booking";

const BookingView = props => {
  const { id } = props.match.params;
  return (
    <Container fluid className="main-content-container">
      <Booking id={id} />
    </Container>
  );
};

export default BookingView;
